import { apiPath } from './api.path';
import { instance } from './axios';

async function getDecisionAPI() {
  return instance.get(apiPath.getDecisions).then((response) => response.data);
}

async function getAllCategoriesAPI(params) {
  console.log('params', params);
  return instance.get(`${apiPath.getAllCategories}/${params}`).then((response) => response.data);
}

async function addDecisionAPI(params) {
  const bodyFormData = new FormData();
  if (params.image) {
    bodyFormData.append('image', params.image);
  }
  bodyFormData.append('name', params.name);
  return instance.post(apiPath.addDecision, bodyFormData).then((response) => response.data);
}

async function deleteDecisionAPI(params) {
  return instance.delete(`${apiPath.deleteDecision}/${params}`).then((response) => response.data);
}

async function addtoDecisionAPI(params) {
  const bodyFormData = new FormData();
  bodyFormData.append('_id', params._id);
  bodyFormData.append('parent', params.parent);
  bodyFormData.append('name', params.name);
  bodyFormData.append('subHeading', params.subHeading);
  bodyFormData.append('content', params.content);
  bodyFormData.append('type', params.type);
  return instance.post(apiPath.addToDecision, bodyFormData).then((response) => response.data);
}

const decisionService = {
  addDecisionAPI,
  getDecisionAPI,
  deleteDecisionAPI,
  getAllCategoriesAPI,
  addtoDecisionAPI
};
export default decisionService;
